import { useState } from "react";
import { Link } from "react-router-dom";
import MediaCard from "@/components/feature/MediaCard";
import { getLatest } from "@/lib/media";

const TABS: { key: "all" | "movie" | "tv"; label: string }[] = [
  { key: "all", label: "全部" },
  { key: "movie", label: "电影" },
  { key: "tv", label: "电视剧" },
];

export default function LatestSection() {
  const [tab, setTab] = useState<"all" | "movie" | "tv">("all");
  const items = getLatest(tab === "all" ? undefined : tab, 6);

  return (
    <section className="bg-background-900/60 py-10 md:py-14" aria-label="最新影视">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="flex items-center gap-2 text-sm font-medium text-accent-400">
              <i className="ri-time-line"></i>
              按更新时间排序
            </span>
            <h2 className="mt-1 font-heading text-xl font-bold text-foreground-50 md:text-3xl">最新影视</h2>
            <p className="mt-2 text-sm text-foreground-400">第一时间收录刚刚上线的电影与电视剧资源</p>
          </div>

          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1 rounded-full bg-background-800 p-1">
              {TABS.map((item) => (
                <button
                  key={item.key}
                  type="button"
                  onClick={() => setTab(item.key)}
                  className={`rounded-full px-3.5 py-1.5 text-sm whitespace-nowrap transition-colors ${
                    tab === item.key
                      ? "bg-primary-500 font-medium text-foreground-50"
                      : "text-foreground-300 hover:text-accent-400"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <Link
              to={tab === "tv" ? "/tv" : "/movie"}
              className="hidden items-center gap-1 text-sm text-foreground-300 transition-colors hover:text-accent-400 sm:flex"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-6">
          {items.map((item) => (
            <MediaCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}